import React from 'react';
import { WagmiProvider } from 'wagmi';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// Tambahkan lightTheme di import ini
import { RainbowKitProvider, lightTheme } from '@rainbow-me/rainbowkit';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { config } from './config/web3Config';
import Layout from './components/Layout';
import ClaimPage from './pages/ClaimPage';
import SwapPage from './pages/SwapPage';

const queryClient = new QueryClient();

function App() {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        {/* Di sini rahasianya: Kita paksa tema bawaannya jadi warna custom */}
        <RainbowKitProvider 
          theme={lightTheme({
            accentColor: '#f4f4f5', // Mengubah background biru jadi abu terang
            accentColorForeground: '#1a1a1a', // Mengubah teks putih jadi hitam
            borderRadius: 'medium', // Lengkungan tombol
          })}
        >
          <BrowserRouter>
            <Layout>
              <Routes>
                <Route path="/" element={<ClaimPage />} />
                <Route path="/swap" element={<SwapPage />} />
              </Routes>
            </Layout>
          </BrowserRouter>
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
}

export default App;